module.exports = {"header":{"bienvenue":["Bienvenue","Welcome"],"mon_espace":["Mon espace","My member area"],"deconnexion":["Déconnexion","Sign out"],"connexion":["Connexion","Sign in"],"inscription":["Inscription","Sign up"]},"header_navigation":{"fermer":["Fermer","Close"],"accueil":["Accueil","Home"]}}


//////////////////
// WEBPACK FOOTER
// ./src/features/Layout/translations/translations_header.json
// module id = 308
// module chunks = 0